<app-mobile-warning backRoute="../../"></app-mobile-warning>

<div class="hello-sign-container page-container" [class.loading]="isLoading">
    <div #helloSignContainer class="hello-sign-target"></div>
</div>
